import { z } from 'zod';

import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export const EmploymentRecordFormShape = (
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>
) =>
	z
		.object({
			employerId: z.string().min(1, tCapManage('employment_record.drawer.employer.required')),
			jobTitle: z.string(),
			employeeReference: z.string(),
			startDate: z.string(),
			endDate: z.string(),
			isPrimaryForEmployee: z.boolean(),
		})
		.superRefine((data, ctx) => {
			const now = Date.now();

			if (data.startDate && new Date(data.startDate).getTime() > now) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['startDate'],
					message: tCapManage('employment_record.drawer.start_date.future_error'),
				});
			}

			if (data.endDate && new Date(data.endDate).getTime() > now) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['endDate'],
					message: tCapManage('employment_record.drawer.end_date.future_error'),
				});
			}

			if (
				data.startDate &&
				data.endDate &&
				new Date(data.startDate).getTime() > new Date(data.endDate).getTime()
			) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['startDate'],
					message: tCapManage('employment_record.drawer.start_date.after_end_error'),
				});
			}
		});
